import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import IconPersonAdd from "@/components/icons/IconPersonAdd.vue";

@Component({
  name: "ActionGuest",
  components: {
    "icon-group-add": IconPersonAdd,
  },
})
class ActionGuest extends Vue {
  @Prop({ type: Function, default: () => null })
  readonly action!: () => any;

  render() {
    return (
      <btn onClick={this.action} color="transparent">
        <icon-base
          name="cart"
          width="25"
          height="20"
          viewBox="0 0 24 24"
          color="#008f85"
          style="margin-right: 5px"
        >
          <icon-group-add />
        </icon-base>
        Узнать цену и остатки
      </btn>
    );
  }
}

export default ActionGuest;
